export default __webpack_public_path__ + "static/arun-talk-7dbb57f17f14e774344094f141dd4846.png";